import { Button, message, Modal, Input, Tag } from 'antd';
import { FC, useState } from 'react';
import styled from 'styled-components';
import emailBaseUrl from '../../methods/emailBaseUrl';

const AccessSection = styled.section`
	display: flex;
	flex-direction: row;
	> span {
		width: 25%;
		/* min-width: 150px; */
	}
	/* &.accessInput {
		width: 30px;
	} */
`;
interface ITerminateNewsLetter {
	newsletter: any;
	text: string;
	setRefresh: Function;
}
const UpdateNewsLetterStatus: FC<ITerminateNewsLetter> = ({
	newsletter,
	text,
	setRefresh,
}) => {
	const [visible, setVisible] = useState(false);
	const [loading, setloading] = useState(false);
	const [accessCode, setAccessCode] = useState('3345constable');

	const updateStatus = async () => {
		try {
			setloading(true);
			const res: any = await emailBaseUrl.patch(
				`/v1/newsletters/${newsletter.id}/status`,
				{
					access_code: accessCode,
					status: text === 'Pause' ? 'paused' : 'pending',
				}
			);
			if (res.status === 200) {
				setloading(false);
				message.success(
					`Sending NewsLetters ${text === 'Pause' ? 'Paused' : 'Resumed'}`
				);
				setVisible(false);
				setRefresh(Math.random());
			}
		} catch (e) {
			setloading(false);
			message.error('Could not complete operation');
		}
	};

	return (
		<div>
			<Tag
				style={{
					cursor: 'pointer',
				}}
				color="volcano"
				onClick={() => setVisible(true)}
			>
				{text}
			</Tag>
			<Modal
				width="50%"
				// footer={null}
				visible={visible}
				footer={[
					<Button
						loading={loading}
						type="primary"
						onClick={() => updateStatus()}
					>
						{text}
					</Button>,
				]}
				onCancel={() => setVisible(false)}
			>
				<strong>
					{`Are you sure you want to ${text} this NewsLetter ${
						newsletter?.subject ? `with Subject "${newsletter?.subject}"` : ''
					}`}
				</strong>
				<br />
				<br />
				<AccessSection>
					<span> Access Code : </span>
					<Input
						className="accessInput"
						value={accessCode}
						placeholder="input access code"
						onChange={(e: any) => setAccessCode(e.target.value)}
					/>
				</AccessSection>
			</Modal>
		</div>
	);
};

export default UpdateNewsLetterStatus;
